var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_2141_38689)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19158 16.0269C11.8444 14.0512 14.9471 12.7487 16.4995 12.1194C20.932 10.3225 21.853 10.0104 22.4533 10.0001C22.5853 9.99784 22.8806 10.0297 23.0718 10.181C23.2333 10.3087 23.2777 10.4812 23.2989 10.6022C23.3202 10.7233 23.3467 10.9991 23.3256 11.2146C23.0854 13.6743 22.0461 19.6433 21.5174 22.3983C21.2936 23.564 20.8531 23.9548 20.4266 23.9931C19.4997 24.0762 18.7959 23.3961 17.8982 22.8225C16.4934 21.9251 15.6998 21.3664 14.3363 20.4907C12.7605 19.4786 13.782 18.9223 14.6801 18.0132C14.9151 17.7753 18.9989 14.1551 19.0779 13.8267C19.0878 13.7856 19.097 13.6325 19.0037 13.5517C18.9103 13.4708 18.7726 13.4985 18.6732 13.5204C18.5323 13.5516 16.2882 14.9972 11.9409 17.8573C11.3039 18.2836 10.7269 18.4913 10.21 18.4804C9.64013 18.4684 8.54391 18.1664 7.72898 17.9082C6.72944 17.5915 5.93502 17.4241 6.0042 16.8863C6.04023 16.6062 6.43602 16.3197 7.19158 16.0269Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2141_38689",
    x1: 0.118666,
    y1: 0,
    x2: 0.118666,
    y2: 31.7627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.3dd1a66d8a9cc2afd933efb14ac70539.svg";
export { ForwardRef as ReactComponent };